export default {"src":"/_next/static/media/searchIcon.633ef381.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};